import type { ReactNode } from 'react';
import { SocialRewardContext } from '../model/rewardContext';
import { useSocialReward } from '../model/useSocialReward';
import { SocialRewardDialog } from './SocialRewardDialog';

/**
 * Подарок за подписку живёт в оболочке приложения (ТЗ главной § 11): строка в боковой панели,
 * карточка на «Сообществе» и ссылка «Пополнить за подписку» в строке создания открывают один
 * диалог. Статус `/me/social-reward` лёгкий (`staleTime` 30 с) и нужен на всех страницах.
 */
export function SocialRewardProvider({ children }: { children: ReactNode }) {
  const reward = useSocialReward();
  return (
    <SocialRewardContext.Provider value={reward}>
      {children}
      <SocialRewardDialog reward={reward} />
    </SocialRewardContext.Provider>
  );
}
